import React, { useState } from 'react';
import PropTypes from "prop-types";

const useInput = ({ type,label,required, updateState }) => {
    const [value, setValue] = useState("");

    const onInputChange = (val) => {
        setValue(val);
        updateState(val);
    };

    const input = (
        <div className="field">
            <div className="control">
                <label className="label">
                    <span className="visually-hidden">{label}</span>                 
                    <input
                            value={value}
                            required={required}
                            className="input"
                            placeholder={label}
                            onChange={e => onInputChange(e.target.value)}
                            type={type} />                    
                        </label>
                    </div>
            </div>);
    return [input];
};

useInput.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    updateState: PropTypes.func.isRequired
}


export default useInput;

